import React, { useState, useEffect } from 'react';

const PersonInputModal = ({ item, onConfirm, onCancel }) => {
  const [personName, setPersonName] = useState('');
  const [previousNames, setPreviousNames] = useState([]);

  useEffect(() => {
    // Retrieve previous names from local storage
    const storedNames = JSON.parse(localStorage.getItem('previousNames')) || [];
    setPreviousNames(storedNames);
  }, []);

  const handleConfirm = () => {
    if (personName.trim()) {
      // Save the new name to local storage
      const updatedNames = [personName.trim(), ...previousNames.filter(name => name !== personName.trim())];
      localStorage.setItem('previousNames', JSON.stringify(updatedNames));
      setPreviousNames(updatedNames);
      onConfirm(personName.trim());
    } else {
      alert('Anna nimi kiitos');
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleNameClick = (name) => {
    setPersonName(name);
  };

  const getClassName = (item) => {
    switch (item) {
      case "Poista tuote":
        return "negative";
      case "Lisää uusi tuote":
        return "positive";
      case "Lisää muu tuote":
        return "positive";
      case "Muuta määrää":
        return "default";
      case "Muokkaa tuotetta":
        return "";
      default:
        return "";
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-window modal-window--narrow">
        <h2 className={`modal-title ${getClassName(item)}`}>{item}</h2>
        <h3 className="modal-description">Syötä henkilön nimi</h3>
        <input
          type="text"
          value={personName}
          onChange={(e) => setPersonName(e.target.value)}
          placeholder="Syötä nimi..."
          className="modal-input"
        />
        <div className="modal-chip-list">
          {previousNames.map((name, index) => (
            <button
              key={index}
              className="modal-chip"
              onClick={() => handleNameClick(name)}
            >
              {name}
            </button>
          ))}
        </div>
        <div className="modal-actions modal-actions--end">
          <button
            className="btn btn-ghost"
            onClick={handleCancel}
          >
            Peru
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
          >
            Hyväksy
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonInputModal;